delete require.cache[require.resolve('../../package.json')];

export const environment = {
  production: true,
  version: require('../../package.json').version,
  bugsnagApiKey: 'b92850cf8482de3731965271ad4267da',
  bugsnagReleaseStage: 'admininterface'  
};
